module.exports = __webpack_public_path__ + "static/img/money_subject.91bb171.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/collection/money_subject.png
// module id = Noah
// module chunks = 4